import React from 'react'
import OppBriefSection from "./OppBriefSection";
import PropTypes from "prop-types";

const SummaryItem = (props) => {
    return (
        <div className="summary-item">
            <p className="summary-item-label">{props.label}</p>
            <p className="summary-item-value">{props.value}</p>
        </div>
    )
};

SummaryItem.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default class OppBriefPayoutSection extends OppBriefSection {

    static sectionTitle = 'Rate';
    static sectionHeader = 'Rate and Fee Estimate';
    static sectionSubtitle = '';

    static TranslationKey = '';

    static CompletedField = 'accepted_payout_at';

    CompletedField = 'accepted_payout_at';

    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        }
    }

    render()
    {
        let {opportunity} = this.props;

        let isBYO = this.props.opportunity.isBYO();

        let hourlyRateLabel = (isBYO && !opportunity.job_candidate?.hourly_rate) ? 'Your Ideal Hourly Rate (From Profile)' : 'HOURLY RATE';

        let estCostLabel = 'ESTIMATED TOTAL FEE';
        if (!isBYO) estCostLabel += '*';



        return (
            <div className="project-brief-payout-section">
                <div className="brief-payout-footer mb-3">

                    <div className="summary-footer">

                        {TB.isDefined(opportunity.job_candidate?.total_hours) && opportunity.estimatedHourlyRate() && (
                            <React.Fragment>
                                <SummaryItem label={hourlyRateLabel} value={TB.formatCurrency(opportunity.estimatedHourlyRate())}/>
                                <SummaryItem label={'NUMBER OF HOURS'} value={opportunity.job_candidate?.total_hours}/>
                            </React.Fragment>
                        )}
                        <SummaryItem label={estCostLabel} value={opportunity.estimatedFee(false)}/>
                        <SummaryItem label={'START AND END DATE'} value={opportunity.panelTimeDisplay()}/>
                    </div>

                </div>


                {opportunity.isBYO()
                    && TB.isDefined(opportunity.project_position?.target_rate) && (
                    <div className="brief-payout-footer mb-3">

                        <h5 className={`summary-header ${opportunity.hasUnseenUpdateToProjectPositionTargetRate() ? 'opp-unseen-update' : ''}`}>
                            Target bill rate for the Project

                        </h5>
                        <div className="summary-footer">
                            <div className="summary-item" style={{flex: 0}}>
                                <p className="summary-item-value mx-5">{TB.formatCurrency(opportunity.project_position?.target_rate)} per hour</p>
                            </div>
                            <div className="summary-item">
                                <p className="summary-item-label text-transform-none" style={{whiteSpace: 'normal'}}>
                                    This rate reflects what the client is wanting to pay for the role.
                                    Typically there is room for negotiation on final bill rate.
                                    You will have the opportunity to propose a final rate as part of your proposal.
                                </p>
                            </div>
                        </div>

                    </div>
                )}
                    <p className="mt-5 text-left font-italic text-sm">
                        {opportunity.isBYO() ?
                            "* Note: final rate will be negotiated with client" :
                            "* Note: This initial fee was estimated based upon the hourly rate you provided in your profile " +
                            "and the assumed timing based upon client scope and deliverables. Final fee is negotiable " +
                            "as part of the proposal development (the next step)."
                        }
                    </p>

            </div>
        );
    }
}